import React from 'react';
import { Box, Button, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const PROJECT_RECORD_SECTIONS = [
    { key: 'site_scheme', label: 'Site & scheme' },
    { key: 'conditions', label: 'Planning & statutory' },
    { key: 'costs', label: 'Costs & funding' },
    { key: 'programme', label: 'Programme' },
    { key: 'design_team', label: 'Team & appointments' },
    { key: 'procurement', label: 'Procurement & contract' },
    { key: 'insurance', label: 'Insurance' },
    { key: 'approved_evidence', label: 'Approved evidence' }
];

export function resolveProjectRecordSection(page) {
    const requestedPage = String(page || '').trim().toLowerCase();
    if (requestedPage === 'cost_tables' || requestedPage === 'drawdown') return 'costs';
    if (PROJECT_RECORD_SECTIONS.some((section) => section.key === requestedPage)) return requestedPage;
    return 'site_scheme';
}

export default function ProjectRecordNavigation({ activePage, onChange }) {
    const activeSection = resolveProjectRecordSection(activePage);

    return (
        <Paper
            component="nav"
            aria-label="Project record sections"
            data-project-record-nav="true"
            variant="outlined"
            sx={{
                p: 0.75,
                borderRadius: 1,
                alignSelf: 'start',
                position: { md: 'sticky' },
                top: { md: 16 },
                minWidth: 0,
                boxShadow: 'none'
            }}
        >
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: '1fr' },
                    gap: 0.4,
                    minWidth: 0
                }}
            >
                {PROJECT_RECORD_SECTIONS.map((section) => {
                    const selected = section.key === activeSection;
                    return (
                        <Button
                            key={section.key}
                            type="button"
                            aria-current={selected ? 'page' : undefined}
                            onClick={() => onChange(section.key)}
                            sx={{
                                minWidth: 0,
                                minHeight: { xs: 50, md: 42 },
                                justifyContent: 'flex-start',
                                borderRadius: 0.75,
                                px: 1.25,
                                color: selected ? 'primary.main' : 'text.secondary',
                                backgroundColor: selected ? (theme) => alpha(theme.palette.primary.main, 0.1) : 'transparent',
                                fontSize: 12,
                                fontWeight: selected ? 850 : 650,
                                textTransform: 'none',
                                whiteSpace: { md: 'nowrap' },
                                '&:hover': {
                                    backgroundColor: (theme) => alpha(theme.palette.primary.main, selected ? 0.14 : 0.06)
                                }
                            }}
                        >
                            {section.label}
                        </Button>
                    );
                })}
            </Box>
        </Paper>
    );
}